export enum ResultCode {
  AUTHORIZED = 'authorized',
  AUTHORISED = 'authorised',
  CANCELLED = 'cancelled',
  PENDING = 'pending',
  RECEIVED = 'received',
  REFUSED = 'refused',
}
